import { render, staticRenderFns } from "./subPage.vue?vue&type=template&id=21015db0&"
import script from "./subPage.vue?vue&type=script&lang=js&"
export * from "./subPage.vue?vue&type=script&lang=js&"
import style0 from "./subPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports